/* RESPONSIBLE TEAM: team-proactive-support */
import ReportBase from 'embercom/routes/apps/app/reports/base/report';
import { inject as service } from '@ember/service';

export default class CustomerSupportOverviewRoute extends ReportBase {
  @service customReportsService;

  beforeModel() {
    let app = this.modelFor('apps.app');
    if (app.get('inboxIsNotActive')) {
      return this.replaceWith('apps.app.inbox');
    }
    this.customReportsService.routeToOverviewPage();
  }
}
